import { Directive } from '@angular/core';

@Directive({
  selector: '[libSwiperItem]',
  standalone: true,
})
export class SwiperItemDirective {}
